import { GlIcon, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../alert.js?vue3';
import { logError } from '~/lib/logger';
import EscalationStatus from '../../../../../../ee/app/assets/javascripts/sidebar/components/incidents/escalation_status.vue?vue3';
import { INCIDENTS_I18N as i18n } from '../../constants';
import { escalationStatusQuery, escalationStatusMutation } from '../../queries/constants';
import { getStatusLabel } from '../../utils';
import SidebarEditableItem from '../sidebar_editable_item.vue?vue3';
export default {
    name: 'SidebarEscalationStatus',
    i18n,
    components: {
        EscalationStatus,
        SidebarEditableItem,
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        iid: {
            type: String,
            required: true
        },
        projectPath: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            status: null,
            isUpdating: false
        };
    },
    apollo: {
        status: {
            context: {
                batchKey: 'MRSidebarData'
            },
            query () {
                return escalationStatusQuery;
            },
            variables () {
                return {
                    fullPath: this.projectPath,
                    iid: this.iid
                };
            },
            update (data) {
                return data.namespace?.issuable?.escalationStatus;
            },
            error (error) {
                const message = this.$options.i18n.fetchError;
                createAlert({
                    message
                });
                logError(message, error);
            }
        }
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.status.loading;
        },
        currentStatusLabel () {
            return getStatusLabel(this.status);
        },
        tooltipText () {
            return `${this.$options.i18n.title}: ${this.currentStatusLabel}`;
        }
    },
    methods: {
        updateStatus (status) {
            this.isUpdating = true;
            this.closeSidebar();
            return this.$apollo.mutate({
                mutation: escalationStatusMutation,
                variables: {
                    status,
                    iid: this.iid,
                    projectPath: this.projectPath
                }
            }).then(({ data: { issueSetEscalationStatus } })=>{
                this.status = issueSetEscalationStatus.issue.escalationStatus;
            }).catch((error)=>{
                const message = this.$options.i18n.updateError;
                createAlert({
                    message
                });
                logError(message, error);
            }).finally(()=>{
                this.isUpdating = false;
            });
        },
        closeSidebar () {
            this.close();
            this.$refs.editable.collapse();
        },
        open () {
            this.$refs.escalationStatus.show();
        },
        close () {
            this.$refs.escalationStatus.hide();
        }
    }
};
